var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:{
    'transform rotate-0': _vm.direction === 'down',
    'transform rotate-180': _vm.direction === 'up',
    'transform rotate-90': _vm.direction === 'right',
    'transform rotate-270': _vm.direction === 'left',
  },attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M4 4.2733L4.94 3.3333L8 6.38663L11.06 3.3333L12 4.2733L8 8.27329L4 4.2733Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4 8.66663L4.94 7.72663L8 10.78L11.06 7.72663L12 8.66663L8 12.6666L4 8.66663Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }